/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CreateDocumentFolderRequestDocumentFolderFromJSON, CreateDocumentFolderRequestDocumentFolderToJSON } from './CreateDocumentFolderRequestDocumentFolder';
export function CreateDocumentFolderRequestFromJSON(json) {
    return CreateDocumentFolderRequestFromJSONTyped(json, false);
}
export function CreateDocumentFolderRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        documentFolder: CreateDocumentFolderRequestDocumentFolderFromJSON(json['document_folder'])
    };
}
export function CreateDocumentFolderRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        document_folder: CreateDocumentFolderRequestDocumentFolderToJSON(value.documentFolder)
    };
}
